import { Box, Button, type ButtonProps, Dropdown, List, Text } from "@saleor/macaw-ui-next";
import { ChevronDown } from "lucide-react";
import { type ReactNode } from "react";

interface ButtonWithDropdownProps extends ButtonProps {
  onClick?: () => void;
  options: Array<{
    label: ReactNode;
    testId?: string;
    onSelect: <T>(params?: T) => void;
  }>;
  testId?: string;
  disabled?: boolean;
}

export const ButtonWithDropdown = ({
  onClick,
  options,
  children,
  testId,
  disabled = false,
  ...buttonProps
}: ButtonWithDropdownProps) => (
  <Dropdown>
    <Dropdown.Trigger>
      <Button data-test-id={testId} onClick={onClick} disabled={disabled} {...buttonProps}>
        {children}
        <ChevronDown />
      </Button>
    </Dropdown.Trigger>
    <Dropdown.Content align="end">
      <Box>
        <List padding={2} borderRadius={4} boxShadow="defaultOverlay" backgroundColor="default1">
          {options.map((item, idx) => (
            <Dropdown.Item key={`dropdown-item-${idx}`}>
              <List.Item
                borderRadius={4}
                paddingX={1.5}
                paddingY={2}
                onClick={item.onSelect}
                data-test-id={item.testId}
              >
                {typeof item.label === "string" ? <Text>{item.label}</Text> : item.label}
              </List.Item>
            </Dropdown.Item>
          ))}
        </List>
      </Box>
    </Dropdown.Content>
  </Dropdown>
);
